/**
 * @ Author: Your name
 * @ Create Time: 2019-05-25 20:12:50
 * @ Modified by: Your name
 * @ Modified time: 2019-05-31 13:44:26
 * @ Description: 处理事件的格式化
 */

// eslint-disable-next-line import/prefer-default-export
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    // const timeStr = time.toString()
    // if (timeStr.length === 10) {
    //   time = parseInt(time) * 1000
    // }
    // eslint-disable-next-line radix
    date = new Date(parseInt(time))
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  return format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = `0${value}`
    }
    return value || 0
  })
}
